import "jquery/dist/jquery.min.js";
import Axios from "axios";
import VueGallery from "vue-gallery";
import UpcomingEvent from '@/pages/upcomingevent/upcomingevent';
var moment = require("moment");
  export default {
    components: {
      VueGallery,
      UpcomingEvent
    },
    filters: {
      date: function (data) {
        var sendDate = "N/A";
        if (data != "" && data != null) {
          sendDate = moment(data).format("DD-MM-YYYY");
        }
        return sendDate;
      },
    },
    data() {
      return {
        VehicleImageEndpoint: Endpoints.Vehicle.Image+ '/',
        ImageEndpoint: Endpoints.Helper.Image+ '/',
        PopupLoader: false,
        ShowLoader: false,
        submitted: false,
        VehicleId: 0,
        CheckFailures: [],
        VehicleChecks: [],
        VehicleNotes: "",
        ShowVehicleNotesModel: false,
        ShowVehicleNotesModelHeading: "Notes",
        NewVehicle:[],
        UpcomingEvent: {},
        fromDate:'',
        toDate:'',
        vrm: '',		
        SearchData:false,
        CompanyChecks:[],
        basic:{
          currentPage: 1,
          totalPages: 0,
      },	
      ShowVehicleCheckImageModel: false,
      excel_data: [],
      lightgallery: [],
      biglightgallery: [],
      gindex: 1,
      galleryoptions: {
        prevClass: "prev",
        nextClass: "next",
      },
      };
    },
    mounted() {
      document.title = pbx_SiteTitle + " - Vehicle Profile";
      this.VehicleId = this.$route.params.VehicleId;
      this.GetVehicleDetail();		
      this.GetVehicleChecksList();
      //this.GetUpcomingEventList();
    },

    methods: {
      GetVehicleDetail() {
        this.ShowLoader = true;
        Axios.post(Endpoints.Vehicle.Get, {
          token: localStorage.getItem("token"),
          vehicle_id: this.VehicleId,
        }).then((Response) => {
          this.ShowLoader = false;
          if (Response?.data?.success) {
            this.NewVehicle = Response.data.vehicle;
            this.vrm = this.NewVehicle.vrm;
          }
        });
      },
      GetUpcomingEventList(){
        Axios.post(Endpoints.Dashboard.UpcomingEvent, {token: localStorage.getItem('token'),'RequestFor':'VehicleChecks','VehicleId':this.VehicleId}).then((Response) => {				
          if (Response?.data?.success) {
            this.UpcomingEvent = Response.data.upcoming_event					
          }
        })
      },  
      ShowVehicleNotes(VehicleCheck, type = "notes") {
        if (VehicleCheck.notes != null && VehicleCheck.notes != "") {
          this.ShowVehicleNotesModel = true;
          this.VehicleNotes = VehicleCheck.notes;
          this.ShowVehicleNotesModelHeading = "Notes";
        }else{
          this.ShowVehicleNotesModel = false;
        }
      },   
      GetVehicleChecksList(type = "") {
        var obj = { token: localStorage.getItem("token") };
        obj.vehicleId = this.VehicleId;
        this.ShowLoader = true;
        if(type == 'search'){
          obj.vrm = this.vrm;
          obj.fromDate = this.fromDate;
          obj.toDate = this.toDate;
          this.SearchData = true;
        }
        Axios.post(Endpoints.VehicleChecks.VehicleChecksList, obj).then(
          (Response) => {
            this.ShowLoader = false;
            if (Response?.data?.success) {
              this.VehicleChecks = Response.data.FleetCheckSubmit;
              this.CompanyChecks = Response.data.CompanyChecks;
              this.SearchData = false;
              this.SetVehicleChecksExcelData();
            }
          }
        );
      },
      SetVehicleChecksExcelData(){
        this.excel_data=[];
        this.VehicleChecks.forEach(element=>{
          var obj={};
          obj['created_at'] = element.created_at
          obj['vrm'] = element.vehicle.vrm
          obj['driver'] = element.driver ?  element.driver.forename+' '+element.driver.surname : 'N/A';
          this.CompanyChecks.forEach(CompanyElement=>{
            obj[CompanyElement.name]='';
            element.value.forEach(ValueElement=>{
              if(ValueElement.company_check_id == CompanyElement.id){
                if(ValueElement.value==1 && ValueElement.warning!=1){
                  obj[CompanyElement.name]='Pass';
                }
                if(ValueElement.value==1 && ValueElement.warning==1){
                  obj[CompanyElement.name]='Warning';
                }
                if(ValueElement.value==2){
                  obj[CompanyElement.name]='Fail';
                }
              }
            });
          });

          if(element.safe == 1)
            obj['safe'] = 'Safe';
          else
            obj['safe'] = 'UnSafe';
  
          obj['notes'] = element.notes;
          
          this.excel_data.push(obj);				
        });		
      },
      ShowVehicleImage(VehicleCheck) {
        this.ShowVehicleCheckImageModel = true;
        this.lightgallery = JSON.parse(JSON.stringify(VehicleCheck.photo));
        this.biglightgallery = JSON.parse(JSON.stringify(VehicleCheck.photo));
        for (var i = 0; i < this.biglightgallery.length; i++) {
          this.biglightgallery[i] =
          Endpoints.Helper.Image + "/"+ this.biglightgallery[i];
        }
      },
    },
    
  };